import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';

import Box from '@mui/material/Box';
import { Typography, useMediaQuery } from '@mui/material';
import Link from '@mui/material/Link';
import { appBarLinks, LOGO_URL } from '../../constants';
import CollapsedMenu from './CollapsedMenu';
import northAmericanLogoMobile from '../../assets/images/north-american-logo.png';
import ArrowDownIconSVGR from '../../assets/svgr/ArrowDownIconSVGR';

const Header = () => {
  const isMobileScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <AppBar sx={{ position: { xs: 'fixed', customheadermobile: 'sticky' } }} className='header-app-bar' color='inherit'>
      <Toolbar disableGutters>
        <Container maxWidth={false}>
          <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
          >
            <Grid>
              <Link href={LOGO_URL} aria-label='Home' className='home-link'>
                {isMobileScreen && <img src={northAmericanLogoMobile} className='north-american-logo-mobile' alt='Logo' />}
                {!isMobileScreen && <span className='home-link-wrapper'><img src={northAmericanLogoMobile} className='north-american-logo-mobile' alt='Logo' /></span>}
              </Link>
            </Grid>
            <Box className='menu'>
              <Toolbar disableGutters>
                <Box sx={{ display: { xs: 'none', customheadermobile: 'block' } }}>
                  <Grid container direction='row' className='link-container' alignContent='center' alignItems='center'>
                    {appBarLinks.map((link) => (
                      <React.Fragment key={link.name.join('-')}>
                        <a
                          aria-label={link.name}
                          className={`header-link ${link.active ? 'active' : ''}`}
                          href={link.url}
                        >
                          <Typography component='span'>
                            {link.name.map((name) => (<p className='title' key={name}>{name}</p>))}
                          </Typography>
                          {
                            link.subLinks?.length > 0
                          && <span className='menu-item-container-arrow-icon'><ArrowDownIconSVGR /></span>
                          }
                        </a>
                        {
                          link.subLinks?.length > 0 && (
                            <Box className='header-sub-link' ml={65.2}>
                              {
                                link.subLinks?.map(({ name, url }) => (
                                  <a href={url} key={url}>
                                    {name.map((text) => (<p key={text}>{text}</p>))}
                                  </a>
                                ))
                              }
                            </Box>
                          )
                        }
                      </React.Fragment>
                    ))}
                  </Grid>
                </Box>
                <Box sx={{ display: { xs: 'block', customheadermobile: 'none' } }} justifyContent='right'>
                  <CollapsedMenu items={appBarLinks} />
                </Box>
              </Toolbar>
            </Box>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
